import { type QueryKey, useQuery } from 'react-query'

import { type RepoPaginatedResponse } from '@webapp/infrastructure/interfaces/repositories/RepoPaginatedResponse'
import { type ListCatalogConfigData } from '@webapp/modules/purchasing/business-logic/types/ListCatalogConfigData'
import { type CatalogPermissionSecondaryCategoryConfigConstructor } from '@webapp/modules/purchasing/entities/CatalogPermissionSecondaryCategoryConfig'
import { catalogAccessQueryConfig } from '@webapp/modules/purchasing/query-configs/catalogAccess'

type UseListCatalogPermissionSecondaryCategoryConfigsModelReturn = {
  data:
    | RepoPaginatedResponse<CatalogPermissionSecondaryCategoryConfigConstructor>
    | undefined
  isLoading: boolean
  error: Error | null
  queryKey: QueryKey
}

export const useListCatalogPermissionSecondaryCategoryConfigsModel = (
  params: ListCatalogConfigData
): UseListCatalogPermissionSecondaryCategoryConfigsModelReturn => {
  const queryConfig = catalogAccessQueryConfig.secondaryCategoryConfigs(params)

  const { data, isLoading, error } = useQuery<
    RepoPaginatedResponse<CatalogPermissionSecondaryCategoryConfigConstructor>,
    Error
  >(queryConfig)

  return {
    data,
    isLoading,
    error: error ?? null,
    queryKey: queryConfig.queryKey,
  }
}
